// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".click-trap{pointer-events:all}.trap-portal{position:absolute;top:0;opacity:0;pointer-events:none}", ""]);
// Exports
module.exports = exports;
